import TextField from "@material-ui/core/TextField";
import { withStyles, makeStyles } from "@material-ui/core/styles";

const CssTextField = withStyles({
    root: {
      fontFamily: "Inter",
     
      fontSize: 14,
      width:250,
  
      "& .MuiInputBase-root": { fontFamily: "Inter" },
      "& .MuiSelect-select.Mui-disabled": {
        color: "#E91E63",
        cursor: "no-drop",
      },
      "& label.Mui-focused": {
        color: "#e2136e",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "#e2136e",
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 24,
        paddingLeft: 18,
        marginBottom: 0,
        fontSize: 14,
        height: 50,
  
        "& fieldset": {
          borderColor: "rgba(226, 232, 240, 1)",
          borderWidth: 1,
        },
        "&:hover fieldset": {
          borderColor: "rgba(226, 232, 240, 1)",
          cursor: "pointer",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#e2136e",
        },
  
        "& .MuiSelect-select:focus": {
          backgroundColor: "transparent",
        },
      },
    },
  })(TextField);

  export default CssTextField